module.exports = __webpack_public_path__ + "static/img/2017-10-19.761a924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/2017-10-19.png
// module id = yB6b
// module chunks = 1